import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import {
  Details,
  Member,
  AvatarWrapper,
  Avatar,
  Name,
  Role,
  Country,
  StyledFlag
} from './styled';

const TeamMember = ({
  firstName,
  lastName,
  role,
  country,
  photo,
  bird,
  onClick,
  ...props
}) => {
  const [imageLoaded, setImageLoaded] = useState(false);
  const [hover, setHovered] = useState(false);
  const splitCountry = country.split('(');
  const countryName = splitCountry?.[0].trim();
  const countryCode = splitCountry?.[1]?.substring(0, splitCountry[1].length - 1);
  const memberImage = photo?.[0]?.url;
  const birdImage = bird?.[0]?.url;

  useEffect(() => {
    const img = new Image();
    img.src = memberImage;
    img.onload = () => {
      setTimeout(() => {
        setImageLoaded(true);
      }, 100);
    };
  }, [photo]);

  const onMouseEnter = () => {
    setHovered(true);
  };

  const onMouseLeave = () => {
    setHovered(false);
  };

  return (
    <Member
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      onClick={onClick}
      {...props}
    >
      <AvatarWrapper>
        {birdImage && <Avatar src={birdImage} imageLoaded={imageLoaded} />}
        <Avatar
          src={memberImage}
          imageLoaded={imageLoaded}
          hideOnHover={birdImage}
          hover={hover}
        />
      </AvatarWrapper>
      <Details>
        <Name>
          {firstName} {lastName}
        </Name>
        <Role>{role}</Role>
        <Country>
          {countryCode && <StyledFlag code={countryCode} />} {countryName}
        </Country>
      </Details>
    </Member>
  );
};

TeamMember.propTypes = {
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  role: PropTypes.string,
  country: PropTypes.string,
  photo: PropTypes.array,
  bird: PropTypes.array,
  onClick: PropTypes.func
};

export default TeamMember;
